import React from 'react';
import classNames from 'classnames/bind';
import { DeviceContainer } from "../../DeviceContainer";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var RecommendationProductsSkeleton = function RecommendationProductsSkeleton(_ref) {
  var skeletonItemsCount = _ref.skeletonItemsCount;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: cn('title', 'skeleton-line')
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('tabs', 'skeleton-line')
  }), /*#__PURE__*/React.createElement(DeviceContainer, {
    contentMaxWidth: 167,
    isFetching: true,
    previewCardsLength: skeletonItemsCount
  }));
};
export { RecommendationProductsSkeleton };